import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {newsletterTargetingBuilder_template} from "./newsletterTargetingBuilder_template";

declare var ko: any;

export class newsletterMailDelivery_template extends vnTemplate {

    //As VM
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected statusTooltip: infoButton_template;
    private statusTooltipContent: string;
    protected filter: filterSimple_template;
    protected templateFilter : multipleSelector_template;
    protected recipientFilter : multipleSelector_template;
    protected statusFilter : multipleSelector_template;
    protected dateFilter: filterDate_template;
    protected filterPreset: filterPreset_template;
    protected transferredTooltip: infoButton_template;
    protected failedTooltip: infoButton_template;
    protected sendsTooltip: infoButton_template;
    protected dateScheduledTooltip: infoButton_template;
    protected deliveriesTooltip: infoButton_template;
    protected deliveryRateTooltip: infoButton_template;
    protected spamComplaintsTooltip: infoButton_template;
    protected spamRateTooltip: infoButton_template;
    protected softBouncesTooltip: infoButton_template;
    protected softBounceRateTooltip: infoButton_template;
    protected hardBouncesTooltip: infoButton_template;
    protected hardBouncesRateTooltip: infoButton_template;
    protected opensTooltip: infoButton_template;
    protected openRateTooltip: infoButton_template;
    protected clicksTooltip: infoButton_template;
    protected clickRateTooltip: infoButton_template;
    protected targetingBuilder: newsletterTargetingBuilder_template;
    private targetingReferences: any = {};

    protected initPartial() {
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.statusTooltipContent = `
            <p>Only “Pending” or "In Progress" requests can be cancelled.</p>
        `;
        this.statusTooltip = new infoButton_template('statusTooltip', this.getTemplateViewModel(), this.caller);
        this.statusTooltip.setTitle('STATUS');
        this.statusTooltip.setContent(this.statusTooltipContent);
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.templateFilter = new multipleSelector_template("templateFilter", this.getTemplateViewModel(), this.caller);
        this.templateFilter.setLabel("Template");
        this.templateFilter.setFilterContainerClass('margin-neg');
        this.templateFilter.setTagContainerId('selected-templates');
        this.templateFilter.setTagContainerCaption('Selected templates:');

        this.recipientFilter = new multipleSelector_template("recipientFilter", this.getTemplateViewModel(), this.caller);
        this.recipientFilter.setLabel("Recipient");
        this.recipientFilter.setFilterContainerClass('margin-neg');
        this.recipientFilter.setTagContainerId('selected-recipients');
        this.recipientFilter.setTagContainerCaption('Selected recipients:');

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("Status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-statuses');
        this.statusFilter.setTagContainerCaption('Selected statuses:');

        let currentDate = new Date();
        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setDateRange(
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 30, 0, 0, 0),
            new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59),
        );
        this.dateFilter.setLabel("Date Scheduled");

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('newsletterDelivery');

        this.transferredTooltip = new infoButton_template('transferredTooltip', this.getTemplateViewModel(), this.caller);
        this.transferredTooltip.setTitle('TRANSFERRED');
        this.transferredTooltip.setContent('<p>Count of emails transferred to the ESP to be sent.</p>');

        this.failedTooltip = new infoButton_template('failedTooltip', this.getTemplateViewModel(), this.caller);
        this.failedTooltip.setTitle('FAILED');
        this.failedTooltip.setContent('<p>Count of emails that were not transferred to the ESP. Invalid emails or email addresses would not be transferred.</p>');

        this.sendsTooltip = new infoButton_template('sendsTooltip', this.getTemplateViewModel(), this.caller);
        this.sendsTooltip.setTitle('SENT');
        this.sendsTooltip.setContent('<p>Count of emails sent by the ESP. Recipients are excluded if they are on a suppression list.</p>');

        this.dateScheduledTooltip = new infoButton_template('dateScheduledTooltip', this.getTemplateViewModel(), this.caller);
        this.dateScheduledTooltip.setTitle('DATE SCHEDULED');
        this.dateScheduledTooltip.setContent('<p>Date emails were scheduled to be sent. Note that data on sends, deliveries, spam complaints, hard bounces, and soft bounces will be provided up to 48 hours after it occurs.</p>');

        this.deliveriesTooltip = new infoButton_template('deliveriesTooltip', this.getTemplateViewModel(), this.caller);
        this.deliveriesTooltip.setTitle('DELIVERIES');
        this.deliveriesTooltip.setContent('<p>Count of emails successfully delivered.</p>');

        this.deliveryRateTooltip = new infoButton_template('deliveryRateTooltip', this.getTemplateViewModel(), this.caller);
        this.deliveryRateTooltip.setTitle('DELIVERY RATE');
        this.deliveryRateTooltip.setContent('<p>Calculated as Deliveries/Emails Sent.</p>');

        this.opensTooltip = new infoButton_template('opensTooltip', this.getTemplateViewModel(), this.caller);
        this.opensTooltip.setTitle('OPENS');
        this.opensTooltip.setContent('<p>Count of emails opened.</p>');

        this.openRateTooltip = new infoButton_template('openRateTooltip', this.getTemplateViewModel(), this.caller);
        this.openRateTooltip.setTitle('OPEN RATE');
        this.openRateTooltip.setContent('<p>Calculated as Opens/Deliveries.</p>');

        this.clicksTooltip = new infoButton_template('clicksTooltip', this.getTemplateViewModel(), this.caller);
        this.clicksTooltip.setTitle('CLICKS');
        this.clicksTooltip.setContent('<p>Count of links clicked from within the email.</p>');

        this.clickRateTooltip = new infoButton_template('clickRateTooltip', this.getTemplateViewModel(), this.caller);
        this.clickRateTooltip.setTitle('CLICK RATE');
        this.clickRateTooltip.setContent('<p>Calculated as Clicks/Deliveries.</p>');

        this.spamComplaintsTooltip = new infoButton_template('spamComplaintsTooltip', this.getTemplateViewModel(), this.caller);
        this.spamComplaintsTooltip.setTitle('SPAM COMPLAINTS');
        this.spamComplaintsTooltip.setContent('<p>Count of deliveries that were marked as spam. These recipients are added to a suppression list.</p>');

        this.spamRateTooltip = new infoButton_template('spamRateTooltip', this.getTemplateViewModel(), this.caller);
        this.spamRateTooltip.setTitle('SPAM RATE');
        this.spamRateTooltip.setContent('<p>Calculated as Complaints/Deliveries.</p>');

        this.softBouncesTooltip = new infoButton_template('softBouncesTooltip', this.getTemplateViewModel(), this.caller);
        this.softBouncesTooltip.setTitle('SOFT BOUNCES');
        this.softBouncesTooltip.setContent('<p>Count of instances where the recipient’s email provider indicated they were temporarily unable to accept a delivery. These are also called general transient bounces.</p>');

        this.softBounceRateTooltip = new infoButton_template('softBounceRateTooltip', this.getTemplateViewModel(), this.caller);
        this.softBounceRateTooltip.setTitle('SOFT BOUNCE RATE');
        this.softBounceRateTooltip.setContent('<p>Calculated as Soft Bounces/Emails Sent.</p>');

        this.hardBouncesTooltip = new infoButton_template('hardBouncesTooltip', this.getTemplateViewModel(), this.caller);
        this.hardBouncesTooltip.setTitle('HARD BOUNCES');
        this.hardBouncesTooltip.setContent('<p>Count of instances where permanent delivery failure is expected. These recipients are added to a suppression list.</p>');

        this.hardBouncesRateTooltip = new infoButton_template('hardBouncesRateTooltip', this.getTemplateViewModel(), this.caller);
        this.hardBouncesRateTooltip.setTitle('HARD BOUNCE RATE');
        this.hardBouncesRateTooltip.setContent('<p>Calculated as Hard Bounces/Emails Sent.</p>');

        this.targetingBuilder = new newsletterTargetingBuilder_template(
            'campaignRecipientLogicTargetingBuilder',
            this.getTemplateViewModel(),
            this.caller
        );
        this.targetingBuilder.setReadOnly(true);
    }

    public getViewModelForRequest(): any {
        return {
            filters: {
                keyword: this.getTemplateViewModel().filter.filterKeyword,
                templates: this.getTemplateViewModel().templateFilter.selectedItems,
                statuses: this.getTemplateViewModel().statusFilter.selectedItems,
                recipients: this.getTemplateViewModel().recipientFilter.selectedItems,
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange()
            },
            searchPresetType: 'newsletterDelivery',
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName()
        }
    }

    protected buildViewModel(): any {
        let self = this
        return {
            deliveries: ko.observableArray([]),
            summary: ko.observable(null),
            idNewsletterMailToCancel: ko.observable(null),
            isRecipientLogicVisible: ko.observable(false),
            recipientLogicTitle: ko.observable('Recipient Logic'),
            recipientLogicSegments: ko.observableArray([]),
            recipientLogicMailingLists: ko.observableArray([]),
            recipientLogicExternalEmails: ko.observableArray([]),
            recipientLogicHasCriteria: ko.observable(false),
            viewType: ko.observable('send'),
            orderBy: ko.observable("dateScheduled"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateScheduled_ASC"),
            permissions: ko.observableArray(this.initPermissions(['newsletter_campaigns'])),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },

            onClickCancel : (data, event)=>{
                self.onClickCancel()
            },
            onClickShowCancel : (data, event)=>{
                self.onClickShowPopUp(data)
            },
            onClickHideCancel : (data, event)=>{
                self.onClickHidePopUp()
            },
            onClickShowRecipientLogic: (data, event) => {
                self.onClickShowRecipientLogic(data);
            },
            onClickHideRecipientLogic: () => {
                self.onClickHideRecipientLogic();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
                <div class="sub-header filter-preset w-justify ">
                        ` + this.filterPreset.getHtmlBuild() + `
                </div>

                <div class="sub-header w-justify">
                    <div class=" w-justify">
                        <div class="w-left">
                            ` + this.dateFilter.getHtmlBuild() + `
                            ` + this.templateFilter.getHtmlBuild() + `
                            ` + this.statusFilter.getHtmlBuild() + `
                            ` + this.recipientFilter.getHtmlBuild() + `
                        </div>
                    </div>
                </div>

                <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                        <div id="selected-templates"></div>
                        <div id="selected-statuses"></div>
                        <div id="selected-recipients"></div>
                    </div>
                </div>

                <div class="list-header w-justify">
                    <div class="w-left" >
                         <div class="form-group row newsletter-filter">
                            <div class="form-check-inline width-auto">
                                <input type="radio" name="viewTypeStats" id="active_yes" value="send" data-bind="checked: viewType"/>
                                <label class="form-label" for="active_yes">Send</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio" name="viewTypeStats" id="active_no" value="performance" data-bind="checked: viewType"/>
                                <label  class="form-label" for="active_no">Performance</label>
                            </div>
                        </div>

                    </div>
                    <div class="w-center" >
                        ` + this.filter.getHtmlBuild() + `
                    </div>
                    <div class="w-right">
                        ` + this.pagination.getHtmlBuild() + `
                    </div>
                </div>

                 <div class="w-list-results" id="list-results">
                                 <table class="list-results" >
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr data-bind="visible: viewType() == 'send'">
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Reference</span></th>
                            <th><span style="width: 280px;" class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'subject') }, css: { 'list-sort-desc': orderByAndDirection()=='subject_DESC', 'list-sort-asc': orderByAndDirection()=='subject_ASC' }">Subject</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'referenceSource') }, css: { 'list-sort-desc': orderByAndDirection()=='referenceSource_DESC', 'list-sort-asc': orderByAndDirection()=='referenceSource_ASC' }">Source</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'b.name') }, css: { 'list-sort-desc': orderByAndDirection()=='b.name_DESC', 'list-sort-asc': orderByAndDirection()=='b.name_ASC' }">Template</span></th>
                            <th><span>Recipients</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'e.firstName') }, css: { 'list-sort-desc': orderByAndDirection()=='e.firstName_DESC', 'list-sort-asc': orderByAndDirection()=='e.firstName_ASC' }">Created By</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateScheduled') }, css: { 'list-sort-desc': orderByAndDirection()=='dateScheduled_DESC', 'list-sort-asc': orderByAndDirection()=='dateScheduled_ASC' }">Scheduled</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateStarted') }, css: { 'list-sort-desc': orderByAndDirection()=='dateStarted_DESC', 'list-sort-asc': orderByAndDirection()=='dateStarted_ASC' }">Started</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateEnded') }, css: { 'list-sort-desc': orderByAndDirection()=='dateEnded_DESC', 'list-sort-asc': orderByAndDirection()=='dateEnded_ASC' }">Ended</span></th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'successCount') }, css: { 'list-sort-desc': orderByAndDirection()=='successCount_DESC', 'list-sort-asc': orderByAndDirection()=='successCount_ASC' }">Transferred</span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.transferredTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'failCount') }, css: { 'list-sort-desc': orderByAndDirection()=='failCount_DESC', 'list-sort-asc': orderByAndDirection()=='failCount_ASC' }">Failed</span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.failedTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sends') }, css: { 'list-sort-desc': orderByAndDirection()=='sends_DESC', 'list-sort-asc': orderByAndDirection()=='sends_ASC' }">Sent</span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.sendsTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'idStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='idStatus_DESC', 'list-sort-asc': orderByAndDirection()=='idStatus_ASC' }">Status
                                    </span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.statusTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th></th>
                        </tr>

                        <tr data-bind="visible: viewType() == 'performance'">
                            <th width="400px"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'subject') }, css: { 'list-sort-desc': orderByAndDirection()=='subject_DESC', 'list-sort-asc': orderByAndDirection()=='subject_ASC' }">Subject</span></th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'dateScheduled') }, css: { 'list-sort-desc': orderByAndDirection()=='dateScheduled_DESC', 'list-sort-asc': orderByAndDirection()=='dateScheduled_ASC' }">Date<br>Scheduled
                                    </span>
                                    <div class="w-tooltips-adv pos-right short">
                                            ` + this.dateScheduledTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'deliveries') }, css: { 'list-sort-desc': orderByAndDirection()=='deliveries_DESC', 'list-sort-asc': orderByAndDirection()=='deliveries_ASC' }">Deliveries
                                    </span>
                                    <div class="w-tooltips-adv pos-right short">
                                            ` + this.deliveriesTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'deliveryRate') }, css: { 'list-sort-desc': orderByAndDirection()=='deliveryRate_DESC', 'list-sort-asc': orderByAndDirection()=='deliveryRate_ASC' }">Delivery %
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.deliveryRateTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'opens') }, css: { 'list-sort-desc': orderByAndDirection()=='opens_DESC', 'list-sort-asc': orderByAndDirection()=='opens_ASC' }">Opens
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.opensTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'openRate') }, css: { 'list-sort-desc': orderByAndDirection()=='openRate_DESC', 'list-sort-asc': orderByAndDirection()=='openRate_ASC' }">Open %
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.openRateTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'clicks') }, css: { 'list-sort-desc': orderByAndDirection()=='clicks_DESC', 'list-sort-asc': orderByAndDirection()=='clicks_ASC' }">Clicks
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.clicksTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'clickRate') }, css: { 'list-sort-desc': orderByAndDirection()=='clickRate_DESC', 'list-sort-asc': orderByAndDirection()=='clickRate_ASC' }">Click %
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.clickRateTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'spamComplaints') }, css: { 'list-sort-desc': orderByAndDirection()=='spamComplaints_DESC', 'list-sort-asc': orderByAndDirection()=='spamComplaints_ASC' }">Spam<br>Complaints
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.spamComplaintsTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'spamRate') }, css: { 'list-sort-desc': orderByAndDirection()=='spamRate_DESC', 'list-sort-asc': orderByAndDirection()=='spamRate_ASC' }">Spam %
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.spamRateTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'softBounces') }, css: { 'list-sort-desc': orderByAndDirection()=='softBounces_DESC', 'list-sort-asc': orderByAndDirection()=='softBounces_ASC' }">Soft<br>Bounces
                                    </span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                            ` + this.softBouncesTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'softBounceRate') }, css: { 'list-sort-desc': orderByAndDirection()=='softBounceRate_DESC', 'list-sort-asc': orderByAndDirection()=='softBounceRate_ASC' }">Soft<br>Bounce %
                                    </span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.softBounceRateTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'hardBounces') }, css: { 'list-sort-desc': orderByAndDirection()=='hardBounces_DESC', 'list-sort-asc': orderByAndDirection()=='hardBounces_ASC' }">Hard<br>Bounces
                                    </span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.hardBouncesTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="w-justify">
                                    <span class="icon list-sort-none has-tooltip" data-bind="event: { click: onClickReorder.bind($data, 'hardBouncesRate') }, css: { 'list-sort-desc': orderByAndDirection()=='hardBouncesRate_DESC', 'list-sort-asc': orderByAndDirection()=='hardBouncesRate_ASC' }">Hard<br>Bounce %
                                    </span>
                                    <div class="w-tooltips-adv pos-left short">
                                            ` + this.hardBouncesRateTooltip.getHtmlBuild() + `
                                    </div>
                                </div>
                            </th>
                            <th><span>Recipients</span></th>
                        </tr>

                    </thead>

                    <!-- ko if: summary() != null -->
                    <tbody>
                        <tr data-bind="visible: viewType() == 'send'" class="list-grand-total">
                            <td class="align-left" colspan="10"><span>Totals</span></td>
                            <td class="align-left"><span data-bind="text: Number(summary().successCount).toLocaleString()"></span></td>
                            <td class="align-left"> <span data-bind="text: Number(summary().failCount).toLocaleString()"/></td>
                            <td class="align-left"><span data-bind="text: Number(summary().sends).toLocaleString()"/></td>
                            <td colspan="2"></td>
                        </tr>

                        <tr data-bind="visible: viewType() == 'performance'" class="list-grand-total">
                            <td class="align-left" colspan="2"><span>Totals</span></td>
                            <td class="align-left"><span data-bind="text: Number(summary().deliveries).toLocaleString()"/></td>
                            <td class="align-left"><span data-bind="text: summary().deliveryRate + '%'"/></td>
                            <td class="align-left"><span data-bind="text: Number(summary().opens).toLocaleString()"/></td>
                            <td class="align-left"><span data-bind="text: summary().openRate + '%'"/></td>
                            <td class="align-left"><span data-bind="text: Number(summary().clicks).toLocaleString()"/></td>
                            <td class="align-left"><span data-bind="text: summary().clickRate + '%'"/></td>
                            <td class="align-left"><span data-bind="text: Number(summary().spamComplaints).toLocaleString()"/></td>
                            <td class="align-left"><span data-bind="text: summary().spamRate + '%'"/></td>
                            <td class="align-left"><span data-bind="text: Number(summary().softBounces).toLocaleString()"/></td>
                            <td class="align-left"><span data-bind="text: summary().softBounceRate + '%'"/></td>
                            <td class="align-left"><span data-bind="text: Number(summary().hardBounces).toLocaleString()"/></td>
                            <td class="align-left"><span data-bind="text: summary().hardBounceRate + '%'"/></td>
                            <td></td>
                        </tr>
                    </tbody>
                    <!-- /ko -->

                    <tbody data-bind="foreach: deliveries">
                        <tr data-bind="visible: $parent.viewType() == 'send'">
                            <td data-bind="text: id"></td>
                            <td><span style="width: 280px;" data-bind="text: subject"></span></td>
                            <td><span data-bind="text: referenceType + '(ID:' + referenceSource + ')' "></span></td>
                            <td><span data-bind="text: templateName"></span></td>
                            <td>
                                <div class="newsletter-recipient-cell">
                                    <span class="newsletter-recipient-text" data-bind="text: recipients, attr: { title: targetingSummary || recipients }"></span>
                                    <button type="button" class="btn border only-icon icon i-view newsletter-recipient-logic-trigger" title="View Recipient Logic" aria-label="View Recipient Logic" data-bind="visible: hasRecipientLogic, event: { click: $parent.onClickShowRecipientLogic }, clickBubble: false"></button>
                                </div>
                            </td>
                            <td><span data-bind="text: (userCreatedFullName != '') ? userCreatedFullName : userCreatedFirstName + ' ' + userCreatedLastName"></span></td>
                            <td><span data-bind="text: dateCreated"></span></td>
                            <td><span data-bind="text: dateScheduled"></span></td>
                            <td><span data-bind="text: dateStarted"></span></td>
                            <td><span data-bind="text: dateEnded"></span></td>
                            <td><span data-bind="text: (successCount == 0) ? '-' : Number(successCount).toLocaleString()"></span></td>
                            <td><span data-bind="text: (failCount == 0) ? '-' : Number(failCount).toLocaleString()"></span></td>
                            <td><span data-bind="text: (sends == null) ? '-' : Number(sends).toLocaleString()"></span></td>
                            <td><span data-bind="class: statusClass, text: status"></span></td>
                            <td>
                                <span data-bind="visible: status == 'Pending' || status == 'In Progress'">
                                    <button style="margin-left: 0.5rem" type="button" data-bind="event: { click: $parent.onClickShowCancel },  visible: $parent.permissions()['newsletter_campaigns'].read, clickBubble: false" class="btn border only-icon highlight icon i-delete"></button>
                                </span>
                            </td>
                        </tr>

                        <tr data-bind="visible: $parent.viewType() == 'performance'">
                            <td><span style="width: 400px;display: block;" data-bind="text: subject"></span></td>
                            <td><span data-bind="text: dateScheduled"></span></td>
                            <td><span data-bind="text: (deliveries == null) ? '-' : Number(deliveries).toLocaleString()"></span></td>
                            <td><span data-bind="text: (deliveryRate == null) ? '-' : deliveryRate + '%' "></span></td>
                            <td><span data-bind="text: (opens == null) ? '-' : Number(opens).toLocaleString()"></span></td>
                            <td><span data-bind="text: (openRate == null) ? '-' : openRate + '%' "></span></td>
                            <td><span data-bind="text: (clicks == null) ? '-' : Number(clicks).toLocaleString()"></span></td>
                            <td><span data-bind="text: (clickRate == null) ? '-' : clickRate + '%' "></span></td>
                            <td><span data-bind="text: (spamComplaints == null) ? '-' : Number(spamComplaints).toLocaleString()"></span></td>
                            <td><span data-bind="text: (spamRate == null) ? '-' : spamRate + '%' "></span></td>
                            <td><span data-bind="text: (softBounces == null) ? '-' : Number(softBounces).toLocaleString()"></span></td>
                            <td><span data-bind="text: (softBounceRate == null) ? '-' : softBounceRate + '%' "></span></td>
                            <td><span data-bind="text: (hardBounces == null) ? '-' : Number(hardBounces).toLocaleString()"></span></td>
                            <td><span data-bind="text: (hardBounceRate == null) ? '-' : hardBounceRate + '%' "></span></td>
                            <td>
                                <div class="newsletter-recipient-cell">
                                    <span class="newsletter-recipient-text" data-bind="text: recipients, attr: { title: targetingSummary || recipients }"></span>
                                    <button type="button" class="btn border only-icon icon i-view newsletter-recipient-logic-trigger" title="View Recipient Logic" aria-label="View Recipient Logic" data-bind="visible: hasRecipientLogic, event: { click: $parent.onClickShowRecipientLogic }, clickBubble: false"></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>

        <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isRecipientLogicVisible }">
            <div class="lightbox-content">
                <div class="w-form lightbox-form newsletter-recipient-logic-dialog">
                    <div class="form-header">
                        <h3 class="form-title" data-bind="text: recipientLogicTitle"></h3>
                        <button type="button" data-bind="event: { click: onClickHideRecipientLogic }" class="close-button icon i-close-2" aria-label="Close"></button>
                    </div>
                    <div class="form-body newsletter-save-send-body">
                        <div class="form-group" data-bind="visible: recipientLogicSegments().length > 0">
                            <label class="form-label">Segment</label>
                            <p class="form-text" data-bind="text: recipientLogicSegments().join(', ')"></p>
                        </div>
                        <div class="form-group" data-bind="visible: recipientLogicMailingLists().length > 0">
                            <label class="form-label">Mailing List</label>
                            <p class="form-text" data-bind="text: recipientLogicMailingLists().join(', ')"></p>
                        </div>
                        <div class="form-group" data-bind="visible: recipientLogicExternalEmails().length > 0">
                            <label class="form-label">Additional Recipients</label>
                            <p class="form-text" data-bind="text: recipientLogicExternalEmails().join(', ')"></p>
                        </div>
                        <div data-bind="visible: recipientLogicHasCriteria">
                            ${this.targetingBuilder.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="delete-dialog" class="w-lightbox light-theme">
            <div class="lightbox-content">
                <div class="w-form lightbox-form">
                    <div class="form-header">
                        <h3 class="form-title">Canceling Newsletter Task</h3>
                        <button type="button"  data-bind="event: { click: onClickHideCancel }" class="close-button icon i-close-2"></button>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <p class="form-text">This action is irreversible.</p>
                            <p class="form-text">Are you sure you want to cancel this delivery task?</p>
                        </div>
                     </div>
                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onClickHideCancel }" class="btn">Cancel</button>
                        <button type="button" data-bind="event: { click: onClickCancel }" class="btn highlight">Cancel Delivery</button>
                    </div>
                </div>
            </div>
            </div>
        `);
    }

    protected getTemplateName(): string {
        return "newsletterMailDelivery_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewNewsletterMail(data, event): any {
        this.caller.viewNewsletterMail(data)
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.filterList();
    }

    private preview(value) {

        //prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();
        this.caller.preview(value.permalink);
    }

    onClickAdd(): any {
        this.caller.addNewsletterMail()
    }

    onClickCancel() {
        let newsletterMailId = this.getTemplateViewModel().idNewsletterMailToCancel();
        this.toggleCancelDialogVisibility();
        this.caller.cancelNewsletterMail(newsletterMailId);
    }

    onClickHidePopUp(): any {
        this.getTemplateViewModel().idNewsletterMailToCancel(null);
        this.toggleCancelDialogVisibility()
    }
    onClickShowPopUp(data): any {

        this.getTemplateViewModel().idNewsletterMailToCancel(data);
        this.toggleCancelDialogVisibility()
    }

    private onClickShowRecipientLogic(delivery: any): void {
        let criteria = delivery.targeting || {};
        if (typeof criteria === 'string') {
            try {
                criteria = JSON.parse(criteria);
            } catch (error) {
                criteria = {};
            }
        }

        let references: any = Object.assign({}, this.targetingReferences);
        references.segments = (this.targetingReferences.segments || []).slice();
        let segmentIds: any = {};
        references.segments.forEach((segment: any) => segmentIds[String(segment.id)] = true);
        (delivery.targetingSegments || []).forEach((segment: any) => {
            if (!segmentIds[String(segment.id)]) {
                references.segments.push(segment);
                segmentIds[String(segment.id)] = true;
            }
        });
        references.mailingLists = (this.targetingReferences.mailingLists || []).slice();
        let mailingListIds: any = {};
        references.mailingLists.forEach((mailingList: any) => mailingListIds[String(mailingList.id)] = true);
        (delivery.targetingMailingLists || []).forEach((mailingList: any) => {
            if (!mailingListIds[String(mailingList.id)]) {
                references.mailingLists.push(mailingList);
                mailingListIds[String(mailingList.id)] = true;
            }
        });

        this.targetingBuilder.setReferences(references);
        this.targetingBuilder.setReadOnly(true);
        this.targetingBuilder.setCriteria(criteria);

        let viewModel = this.getTemplateViewModel();
        let segmentNames = (delivery.targetingSegments || []).map((segment: any) => segment.title);
        let mailingListNames = (delivery.targetingMailingLists || []).map((mailingList: any) => mailingList.name);
        let externalEmails = (criteria.externalEmails || []).concat(delivery.additionalRecipients || []);
        let seenEmails: any = {};
        externalEmails = externalEmails.map((email: any) => String(email).trim().toLowerCase()).filter((email: string) => {
            if (!email || seenEmails[email]) {
                return false;
            }
            seenEmails[email] = true;
            return true;
        });
        let hasCriteria = (criteria.filterGroups || criteria.groups || []).length > 0
            || (criteria.exclusionGroups || []).length > 0;
        viewModel.recipientLogicTitle('Recipient Logic - ' + (delivery.subject || 'Campaign'));
        viewModel.recipientLogicSegments(segmentNames);
        viewModel.recipientLogicMailingLists(mailingListNames);
        viewModel.recipientLogicExternalEmails(externalEmails);
        viewModel.recipientLogicHasCriteria(hasCriteria);
        viewModel.isRecipientLogicVisible(true);
        document.body.classList.add('is-fixed');
    }

    private onClickHideRecipientLogic(): void {
        let viewModel = this.getTemplateViewModel();
        viewModel.isRecipientLogicVisible(false);
        viewModel.recipientLogicSegments([]);
        viewModel.recipientLogicMailingLists([]);
        viewModel.recipientLogicExternalEmails([]);
        viewModel.recipientLogicHasCriteria(false);
        document.body.classList.remove('is-fixed');
    }

    //Action on view model
    protected setDeliveries(deliveries) {
        this.getTemplateViewModel().deliveries(deliveries)
    }

    protected setSummary(data) {
        this.getTemplateViewModel().summary(data)
    }

    public toggleCancelDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    public setTemplateFilterItems(items){

        this.templateFilter.setItems(items);
    }

    public setStatusFilterItems(items){
        this.statusFilter.setItems(items);
    }

    public setRecipientFilterItems(items){
        this.recipientFilter.setMultiSectionItems(items);
    }

    public setTargetingReferences(references: any): void {
        this.targetingReferences = references || {};
        this.targetingBuilder.setReferences(this.targetingReferences);
        this.targetingBuilder.setReadOnly(true);
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();``
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if(urlParams.startDateRange || urlParams.endDateRange){
                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            this.setFilterSelectedItems(this.templateFilter, urlParams.templates);
            this.setFilterSelectedItems(this.statusFilter, urlParams.statuses);
            this.setFilterSelectedItems(this.recipientFilter, urlParams.recipients);
        }
    }

    private setDateFilters(startDate, endDate) {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public setDefaults(){

        // date filters.
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        this.dateFilter.setRange("-30d", null);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterMailDelivery_template.ts